<div class="container-lg ht-grid list-articles mb-5 px-0">
    <div class="container-article-summary" *ngFor="let article of articles.reverse(); let i = index">
        <app-article-summary [article]="article" (click)="onViewArticle(i)"></app-article-summary>
    </div>
</div>
